import React, { useMemo } from "react"
import { Table, Typography } from "@mimber/ui-web"
import type { ColumnsType } from "@mimber/ui-web"
import type { OrderAmountDueBreakdownTableProps } from "./OrderAmountDueBreakdownTable.types"
import {
  createOrderAmountDueBreakdownRows,
  type OrderAmountDueBreakdownRow,
} from "./OrderAmountDueBreakdownTable.utils"

const { Text } = Typography

export const OrderAmountDueBreakdownTable: React.FunctionComponent<
  OrderAmountDueBreakdownTableProps
> = ({ order }) => {
  const rows = useMemo(
    () => createOrderAmountDueBreakdownRows({ order }),
    [order]
  )

  const columns: ColumnsType<OrderAmountDueBreakdownRow> = useMemo(
    () => [
      {
        title: "Item",
        dataIndex: "item",
        key: "item",
        render: (item: string, record: OrderAmountDueBreakdownRow) =>
          record.key === "member-total" ? <Text strong>{item}</Text> : item,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        align: "right",
        render: (amount: string, record: OrderAmountDueBreakdownRow) =>
          record.key === "member-total" ? <Text strong>{amount}</Text> : amount,
      },
    ],
    []
  )

  return (
    <Table<OrderAmountDueBreakdownRow>
      columns={columns}
      dataSource={rows}
      rowKey="key"
      pagination={false}
      size="small"
      bordered
    />
  )
}
